import classnames from 'classnames/bind';
import { FC, memo, useEffect } from 'react';
import { ContentsProps } from '../types';
import { BusinessDocumentSection } from './components/BusinessDocumentSection';
import { EDocMetadataSection } from './components/EDocMetadataSection';
import { useFileInfoDrawerData } from './hooks/useFileInfoDrawerData';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const Contents: FC<ContentsProps> = memo(
  ({
    businessDoc,
    error,
    onFileNameLoaded,
    onCloseDetailDrawer,
    fnCheckPermission,
  }) => {
    const { labels, eDocMetaProps, leftRightRatio, navigate, fileName } =
      useFileInfoDrawerData(
        businessDoc,
        error,
        onCloseDetailDrawer,
        fnCheckPermission
      );

    useEffect(() => {
      if (fileName && onFileNameLoaded) {
        onFileNameLoaded(fileName);
      }
    }, [fileName, onFileNameLoaded]);

    if (error || !businessDoc) {
      return null;
    }

    return (
      <div className={cx('container')}>
        <BusinessDocumentSection
          businessDoc={businessDoc}
          labels={labels}
          leftRightRatio={leftRightRatio}
          navigate={navigate}
        />

        {eDocMetaProps && <EDocMetadataSection eDocMetaProps={eDocMetaProps} />}
      </div>
    );
  }
);
Contents.displayName = 'Contents';
